var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ins',{staticClass:"adsbygoogle",staticStyle:{"display":"inline-block","width":"728px","height":"90px"},attrs:{"data-ad-client":"ca-pub-8850793267495641","data-ad-slot":"5278413770"}})}
var staticRenderFns = []

export { render, staticRenderFns }